import { render, staticRenderFns } from "./request-aoi-list.vue?vue&type=template&id=4f527c45&scoped=true&"
import script from "./request-aoi-list.vue?vue&type=script&lang=js&"
export * from "./request-aoi-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f527c45",
  null
  
)

export default component.exports